import { useNewNavigate, usePensionNameValue } from "@/shared/client";
import { type SpecialDmaxInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Flex, Grid, Spinner, Text } from "@chakra-ui/react";
import { useRef } from "react";
import { Carousel } from "react-responsive-carousel";
import { CustomTitle } from "./specialPreview.style";

export const SpecialPreview = ({ special }: { special: SpecialDmaxInfoResponse }) => {
    const { onNavigate } = useNewNavigate();
    const pensionName = usePensionNameValue();
    const carouselRef = useRef<Carousel>(null);
    const { isMobile } = MEDIA();

    const { specials } = { ...special };
    const handlePrev = () => {
        carouselRef.current?.moveTo(carouselRef.current.state.selectedItem - 1);
    };
    const handleNext = () => {
        carouselRef.current?.moveTo(carouselRef.current.state.selectedItem + 1);
    };
    const groupedSpeicalList = isMobile
        ? specials.map((t) => [t])
        : specials.reduce(
              (result, t, index) => {
                  if (index % 3 === 0) result.push([]);
                  result[result.length - 1].push(t);
                  return result;
              },
              [] as Array<(typeof specials)[number][]>,
          );

    return groupedSpeicalList ? (
        <Center as="section">
            <Center
                position="relative"
                flexDir="column"
                rowGap="24px"
                maxW="1600px !important"
                w="100%"
                overflow="hidden"
                p={isMobile ? "0 16px" : "0 48px"}
            >
                <Flex w="100%" flexDir="column">
                    <CustomTitle as="h3">{pensionName.kor}의 특별함</CustomTitle>
                    <Text fontFamily="Noto Serif KR" fontSize={isMobile ? "24px" : "40px"} color="#333">
                        SPECIAL FACILITY
                    </Text>
                </Flex>
                <Box w="100%" position="relative">
                    <Carousel
                        ref={carouselRef}
                        showIndicators={false}
                        showArrows={false}
                        showStatus={false}
                        infiniteLoop
                    >
                        {groupedSpeicalList.map((group) => (
                            <Grid
                                key={Math.random()}
                                gridTemplateColumns={isMobile ? "repeat(1,1fr)" : "repeat(3,1fr)"}
                                w="100%"
                                columnGap={isMobile ? "0" : "24px"}
                            >
                                {group.map((special) => (
                                    <Flex
                                        key={special.special_idx}
                                        flexDir="column"
                                        rowGap={isMobile ? "16px" : "24px"}
                                    >
                                        <Box
                                            position="relative"
                                            h={isMobile ? "320px" : "598px"}
                                            background={
                                                special.imgList[0]
                                                    ? `url(${special.imgList[0].img_URL}) no-repeat center/cover`
                                                    : "gray.100"
                                            }
                                            overflow="hidden"
                                            _after={{
                                                content: '""',
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                w: "100%",
                                                h: "100%",
                                                bg: "#000",
                                                opacity: 0,
                                                transition: "opacity 0.3s ease-in-out",
                                                zIndex: 1,
                                            }}
                                            _hover={{
                                                // PC에서만 hover 효과 적용
                                                _after: {
                                                    opacity: [null, null, 0.2], // md 이상에서만 적용
                                                },
                                                ".hover-view": {
                                                    opacity: [null, null, 1],
                                                },
                                            }}
                                        >
                                            <Center
                                                className="hover-view"
                                                top="50%"
                                                left="50%"
                                                transform="translate(-50%,-50%)"
                                                position="absolute"
                                                w="88px"
                                                h="88px"
                                                background="rgba(255,255,255,0.8)"
                                                borderRadius="64px"
                                                opacity={0}
                                                transition="opacity 0.3s ease-in-out"
                                                zIndex={2}
                                                cursor="pointer"
                                                onClick={() => onNavigate({ path: `/specials/${special.special_idx}` })}
                                            >
                                                <Text
                                                    fontFamily="Cormorant"
                                                    fontSize="12px"
                                                    fontWeight="700"
                                                    lineHeight="120%"
                                                    color="#a8a8a8"
                                                >
                                                    MORE VIEW
                                                </Text>
                                            </Center>
                                        </Box>

                                        <Flex
                                            alignItems="flex-start"
                                            justifyContent="flex-start"
                                            flexDir="column"
                                            rowGap={isMobile ? "16px" : "24px"}
                                            sx={{
                                                "& p": {
                                                    textAlign: "left",
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    "& p": {
                                                        fontFamily: "Noto Serif KR",
                                                        lineHeight: "140%",
                                                        color: "#333",
                                                    },
                                                }}
                                            >
                                                <Text fontWeight="400" fontSize="24px">
                                                    {special.special_name.kor}
                                                </Text>
                                                <Text fontWeight="600" fontSize="26px">
                                                    {special.special_name.eng}
                                                </Text>
                                            </Box>
                                            <Text
                                                fontFamily="Comorant"
                                                fontWeight="500"
                                                fontSize="16px"
                                                lineHeight="120%"
                                                color="#6b6b6b"
                                                cursor="pointer"
                                                onClick={() => onNavigate({ path: `/specials/${special.special_idx}` })}
                                            >
                                                MORE VIEW
                                            </Text>
                                        </Flex>
                                    </Flex>
                                ))}
                            </Grid>
                        ))}
                    </Carousel>
                    <Center
                        position="absolute"
                        w={isMobile ? "48px" : "80px"}
                        h={isMobile ? "48px" : "80px"}
                        top={isMobile ? "33%" : "38%"}
                        left="0"
                        transform="translateY(-50%)"
                        background="rgba(0,0,0,0.4)"
                        cursor="pointer"
                        onClick={handlePrev}
                    >
                        <Box
                            w={isMobile ? "12px" : "20px"}
                            h={isMobile ? "24px" : "40px"}
                            background={`url(${process.env.PUBLIC_URL}/assets/wLeft_arrow.png) no-repeat center/cover`}
                        />
                    </Center>
                    <Center
                        position="absolute"
                        w={isMobile ? "48px" : "80px"}
                        h={isMobile ? "48px" : "80px"}
                        top={isMobile ? "33%" : "38%"}
                        right="0"
                        transform="translateY(-50%)"
                        background="rgba(0,0,0,0.4)"
                        cursor="pointer"
                        onClick={handleNext}
                    >
                        <Box
                            w={isMobile ? "12px" : "20px"}
                            h={isMobile ? "24px" : "40px"}
                            background={`url(${process.env.PUBLIC_URL}/assets/wRight_arrow.png) no-repeat center/cover`}
                        />
                    </Center>
                </Box>
            </Center>
        </Center>
    ) : (
        <Spinner />
    );
};
